import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { Button, Row } from "antd";
import "./EditCalendarInfo.css";
import AddCalendarModal from "./AddCalendarModal";

const localizer = momentLocalizer(moment);
type Appointment = {
  title: any;
  date: Date;
  duration: number;
  patient: {
    name: string;
    surname: string;
  };
};

const CalendarRegistery = () => {
  const [appointments, setAppointments] = useState<Appointment[]>([]);

  useEffect(() => {
    fetch("/api/appointments")
      .then((response) => response.json())
      .then((data: Appointment[]) => setAppointments(data))
      .catch((error) => {
        console.error("Errore nel recupero degli appuntamenti:", error);
      });
  }, []);

  console.log("appu: ", { appointments });

  return (
    <>
     
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    
        <div style={{ height: "85%", width: "90%" }}>
          <Calendar
        localizer={localizer}
        events={appointments.map((appointment) => ({
          title: `Appuntamento con ${appointment.title}`,
          start: new Date(appointment.date),
          end: moment(appointment.date)
            .add(appointment.duration, "minutes")
            .toDate(),
        }))}
        style={{ width: "100%" }}
          />
        </div>
      </div>
     
    </>
  );
};

export default CalendarRegistery;
